import { createRouteRef } from "@backstage/core-plugin-api";

export const pluginId = "misc";

export const rootRouteRef = createRouteRef({
    id: pluginId,
});
